import React from 'react';

import Header from '../../components/user/header/Header.jsx';
import SubIntro from '../../components/user/sub_intro2/Intro.jsx';
import Content from '../../components/user/sub2_1/sub2_1_1/Content.jsx';

import Footer from '../../components/user/footer/Footer.jsx';

import s2_1_1_bg from '../../assets/images/s2_1_1_bg.png';

import '../../styles/user/common.css';
import '../../styles/user/default.css';
import '../../styles/user/fixed.css';
import '../../styles/user/font.css';
import '../../styles/user/footer.css';
import '../../styles/user/header.css';
import '../../styles/user/main.css';
import '../../styles/user/slick-theme.css';
import '../../styles/user/slick.css';
import '../../styles/user/sub.css';

export default function Sub2_1_1() {
  return (
    <>
      <Header />
      <SubIntro
        backgroundImage={s2_1_1_bg}
        mainTitle="서빙로봇의 혁신"
        productName="CREAMBOT"
        productModel="T10"
        description="전면의 대형 디스플레이로 서빙과 동시에
강력한 마케팅 효과가 펼쳐집니다."
  showWhiteFilter={true}
      />
      <Content />
      <Footer />
    </>
  );
}
